import React from 'react';
import './style.css';
import SearchCustomerForm from '../search-customer-form';
import SearchBookingForm from "../search-booking-form";
import SearchPaymentForm from '../search-payment-form';
import { isBifrostAuthConfig } from '../../utils/auth-utils';

export default function SearchContainerView() {

  return (
    <div className="search-container-group">
      <div data-testid="searchContainer" className="flex-container">
        <div data-testid="searchComponent" className="flex-child">
          <SearchCustomerForm />
        </div>
      </div>
      <div className="search-container-group">
        <div data-testid="searchContainer" className="flex-container">
          <div data-testid="searchComponent" className="flex-child">
            <SearchBookingForm />
          </div>
        </div>
      </div>

      {
        isBifrostAuthConfig() && <div className="search-container-group">
          <div data-testid="searchContainer" className="flex-container">
            <div data-testid="searchComponent" className="flex-child">
              <SearchPaymentForm />
            </div>
          </div>
        </div>
      }
    </div>
  );
}
